import React from 'react';

function Region(props) {

    return (
        <div><h1>Region</h1></div>
    )
}

export default Region;